// extracted by mini-css-extract-plugin
export var callCard = "_px-0";
export var callMessageButton = "_px-1";
export var helpIcon = "_px-3";
export var helpIconContainer = "_px-4";
export var verticalDivider = "_px-2";